/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Show_Differences_OnlyInputs */



/**
* | output |
* | --- |
* | "Show differences only" |
*
* @param {Compare_Event_Groups_Show_Differences_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_show_differences_only = /** @type {((inputs?: Compare_Event_Groups_Show_Differences_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Show_Differences_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher uniquement les différences")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Unterschiede anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra solo le differenze")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать только различия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar solo diferencias")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("仅显示差异")
	if (locale === "ja") return /** @type {LocalizedString} */ ("相違点のみ表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केवल अंतर दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar apenas as diferenças")
	return /** @type {LocalizedString} */ ("Show differences only")
});